export default "__VITE_ASSET___Z5R_ehc__"